/** @format */

import createMutation from "src/api/create-mutation.js";

//activate account
export const useActivateAccount = createMutation({
  url: "/auth/activate",
  method: "POST",
});

//forget password
export const useForgotPassword = createMutation({
  url: "/auth/forget_password",
  method: "POST",
});

//generate new access token by refresh token
export const useGenerateNewAccessTokenByRefreshToken = createMutation({
  url: "/auth/refresh-token",
  method: "POST",
});

//register company
export const useRegisterCompany = createMutation({
  url: "/auth/register/company",
  method: "POST",
});

//register user
export const useRegisterUser = createMutation({
  url: "/auth/register/user",
  method: "POST",
});

//reset password
export const useResetPassword = createMutation({
  url: "/auth/reset_password",
  method: "POST",
});

//company sign in
// export const useEmployerRegister = createMutation({
//   url: "/auth/login/admin",
//   method: "POST",
// });
export const useCompanySignIn = createMutation({
  url: "/auth/signin/company",
  method: "POST",
});

//user sign in
export const useUserSignIn = createMutation({
  url: "/auth/signin/user",
  method: "POST",
});

//sign out
export const useSignOut = createMutation({
  url: "/auth/signout",
  method: "POST",
});

//validate
export const useValidateAccount = createMutation({
  url: "/auth/validate",
  method: "POST",
});

// export const useUserRegister = createMutation({
//   url: "/auth/login/user",
//   method: "POST",
// });
